import { apiBookingManager } from "@/services/api-booking-manager";
import { AxiosError } from "axios";
import {
  UpdateBookingApiParams,
  UpdateBookingApiResponse,
} from "./update-booking.types";

export const UpdateBookingApi = async (params: UpdateBookingApiParams) => {
  try {
    const bookingStartDate = new Date(params.data.start_date);
    const formattedStartDate = `${bookingStartDate.getUTCFullYear()}-${String(bookingStartDate.getUTCMonth() + 1).padStart(2, "0")}-${String(bookingStartDate.getUTCDate()).padStart(2, "0")} 00:00:00`;

    const bookingEndDate = new Date(params.data.end_date);
    const formattedEndDate = `${bookingEndDate.getUTCFullYear()}-${String(bookingEndDate.getUTCMonth() + 1).padStart(2, "0")}-${String(bookingEndDate.getUTCDate()).padStart(2, "0")} 00:00:00`;

    const dataFormatted = {
      private_office_id: params.data.private_office_id,
      type: 6,
      on_demand: false,
      company_id: params.data.company,
      app_type: 3,
      notes: "",
      is_edit: true,
      bookings: [
        {
          booking_start: formattedStartDate,
          booking_end: formattedEndDate,
          months_quantity: 1,
          users_quantity: params.data.number_members,
          payout_rate_percentual: params.data.take,
          booking_payout: params.data.transfer,
          credits: params.data.credits,
          booking_commission_fee: params.data.booking_commission_fee,
        },
      ],
    };

    const { data } = await apiBookingManager.post<UpdateBookingApiResponse>(
      `/bookings/privateoffice?edit=true`,
      dataFormatted,
    );

    return {
      data: data,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      data: error?.response?.data as UpdateBookingApiResponse,
    };
  }
};
